import { render, staticRenderFns } from "./atividades.vue?vue&type=template&id=dbd2bb10&"
import script from "./atividades.vue?vue&type=script&lang=js&"
export * from "./atividades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports